import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  pageContent: string;
  pageTitle: string;
  useRebrandedLayout: boolean;

  constructor(
    private configService: ConfigService, private featureFlagService: FeatureFlagsService
  ) {
    this.pageTitle = this.configService.getTextFromKey('privacy-page-title');
    this.pageContent = this.configService.getTextFromKey('privacy-page-content');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {}
}
